/**
 * Pure URL joining helper for the API client.
 *
 * Extracted from `client.ts` so unit tests can exercise it without
 * triggering the module-load-time `getBaseUrl()` call (which throws
 * when `VITE_API_BASE_URL` is unset).
 */

/** Join API base URL and path (trailing/leading slashes normalized). */
export function joinApiUrl(baseUrl: string, path: string): string {
  return `${baseUrl.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
}
